/**
 * Event comments API. Interfaces copied from flock-expo/src/services/api.ts
 * (that file is RN-entangled; the contracts are identical).
 */
import { api } from '@/lib/apiClient';

export interface EventComment {
  id: string;
  text: string;
  createdAt: string;
  editedAt: string | null;
  reactions: Record<string, string[]>;
  author: {
    id: string;
    name: string;
    avatarUrl: string | null;
  };
}

export interface EventCommentsResponse {
  success: boolean;
  data: {
    comments: EventComment[];
    pagination: {
      total: number;
      limit: number;
      offset: number;
      hasMore: boolean;
    };
  };
}

export interface EventCommentResponse {
  success: boolean;
  data: EventComment;
}

export const eventCommentsAPI = {
  listComments: (eventId: string, params?: { limit?: number; offset?: number }) => {
    const searchParams = new URLSearchParams();
    if (params?.limit) searchParams.append('limit', params.limit.toString());
    if (params?.offset) searchParams.append('offset', params.offset.toString());
    const qs = searchParams.toString();
    return api.get<EventCommentsResponse>(`/events/${eventId}/comments${qs ? `?${qs}` : ''}`);
  },

  addComment: (eventId: string, text: string) =>
    api.post<EventCommentResponse>(`/events/${eventId}/comments`, { text }),

  editComment: (eventId: string, commentId: string, text: string) =>
    api.put<EventCommentResponse>(`/events/${eventId}/comments/${commentId}`, { text }),

  deleteComment: (eventId: string, commentId: string) =>
    api.delete<{ success: boolean; message: string }>(
      `/events/${eventId}/comments/${commentId}`
    ),

  reactToComment: (eventId: string, commentId: string, emoji: string) =>
    api.post<{
      success: boolean;
      data: { reactions: Record<string, string[]>; action: string };
    }>(`/events/${eventId}/comments/${commentId}/react`, { emoji }),
};
